module.exports = __webpack_public_path__ + "img/ios.51dc0828.png";